module.exports = __webpack_public_path__ + "static/media/04.1d8c0262.png";